import { render } from "./PersonDot.vue?vue&type=template&id=21b35b16&scoped=true"
import script from "./PersonDot.vue?vue&type=script&lang=js"
export * from "./PersonDot.vue?vue&type=script&lang=js"

import "./PersonDot.vue?vue&type=style&index=0&id=21b35b16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b35b16"]])

export default __exports__